<template>
  <el-dialog
    title="调拨单导出"
    :visible="show"
    width="800px"
    @close="$emit('update:show', false)"
  >
    <div v-if="item.id">
      <div class="option-btn">
        <el-button
          type="primary"
          icon="el-icon-printer"
          size="mini"
          round
          plain
          v-print="'#printContent'"
          >打印</el-button
        >
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-download"
          round
          plain
          @click="downloadPdf()"
          >下载PDF</el-button
        >
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-download"
          round
          plain
          @click="downloadExcel()"
          >导出excel</el-button
        >
      </div>
      <div id="printContent">
        <div class="print-title">调拨单</div>
        <el-descriptions title="" class="mb-10" :column="3">
          <el-descriptions-item label="单号">{{
            item.order_number
          }}</el-descriptions-item>
          <el-descriptions-item label="单据类型">
            <ItemStatus
              :status="item.category"
              model="supplyCategory"
            ></ItemStatus>
          </el-descriptions-item>
          <el-descriptions-item label="接收地">{{
            item.receive_well.well_number || item.approve_base.name
          }}</el-descriptions-item>
          <el-descriptions-item label="发起地">{{
            item.well.well_number || item.base.name
          }}</el-descriptions-item>
          <el-descriptions-item label="创建人">{{
            item.user.name
          }}</el-descriptions-item>
          <el-descriptions-item label="发出时间">
            {{ item.send_date }}
          </el-descriptions-item>
          <el-descriptions-item label="发货方式">
            <ItemStatus
              :status="item.delivery_category"
              model="supplyDelivery"
            ></ItemStatus>
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="3">
            {{ item.remark }}
          </el-descriptions-item>
        </el-descriptions>
        <div style="display: flex; justify-content: center">
          <el-table border :data="item.items" style="width: 100%">
            <el-table-column
              label="序号"
              type="index"
              width="50"
              align="center"
            />
            <el-table-column label="类型">
              <template slot-scope="scope">
                {{ ApplyItemCategoryMap[scope.row.category] }}
              </template>
            </el-table-column>
            <el-table-column label="物资编号" min-width="100px">
              <template slot-scope="scope">
                <template v-if="scope.row.product_id">
                  {{ scope.row.product.code }}（{{ scope.row.product.name }}）
                </template>
                <template v-if="scope.row.item_id">
                  {{ scope.row.item.code }}（{{ scope.row.item.name }}）
                </template>
              </template>
            </el-table-column>
            <el-table-column label="数量" align="center">
              <template slot-scope="scope">
                {{ scope.row.number || 1 }}
              </template>
            </el-table-column>
            <el-table-column label="规格型号" align="center">
              <template slot-scope="scope">{{
                scope.row.product_id
                  ? getProductCustomParam(
                      scope.row.product.custom_params,
                      ['规格型号', '规格', '型号'],
                      scope.row.product_template,
                    )
                  : scope.row.item.model_number
              }}</template>
            </el-table-column>
            <el-table-column label="销售地" align="center">
              <template slot-scope="scope">{{
                getProductCustomParam(
                  scope.row.product_id
                    ? scope.row.product.custom_params
                    : scope.row.item.custom_params,
                  ['销售地'],
                )
              }}</template>
            </el-table-column>
            <el-table-column label="特性1" align="center">
              <template slot-scope="scope">{{
                getProductCustomParam(
                  scope.row.product_id
                    ? scope.row.product.custom_params
                    : scope.row.item.custom_params,
                  ['特性1'],
                )
              }}</template>
            </el-table-column>
            <template v-if="item.category == 2">
              <el-table-column
                label="使用时间"
                prop="used_date"
                align="center"
              ></el-table-column>
              <el-table-column
                label="返厂原因"
                prop="return_reason"
              ></el-table-column>
            </template>
            <el-table-column label="备注" prop="remark"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  ApplyItemCategoryMap,
  DeliveryCategoryMap,
  SupplyCategoryMap,
} from '@/config/global'
import print from 'vue-print-nb'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  directives: {
    print,
  },
  props: {
    item: Object,
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ApplyItemCategoryMap,
    }
  },
  methods: {
    downloadExcel() {
      if (this.downloading) return
      this.downloading = true
      import('@/vendor/Export2Excel').then((excel) => {
        let tHeader = [
          '序号',
          '类型',
          '名称',
          '物资编号',
          '数量',
          '规格型号',
          '销售地',
          '特性1',
        ]
        if (this.item.category == 2) {
          tHeader = tHeader.concat(['使用时间', '返厂原因'])
        }
        tHeader.push('备注')

        let firstRow = Array(tHeader.length).fill('')
        firstRow[0] = `单号：${this.item.order_number}`
        firstRow[1] = `单据类型：${SupplyCategoryMap[this.item.category]}`
        firstRow[2] = `接收地：${
          this.item.receive_well.well_number || this.item.approve_base.name
        }`

        let data = [
          firstRow,
          [
            `发起地：${this.item.well.well_number || this.item.base.name}`,
            `创建人：${this.item.user.name}`,
            `发出时间：${this.item.send_date}`,
          ],
          [
            `发货方式：${DeliveryCategoryMap[this.item.delivery_category]}`,
            `备注：${this.item.remark.replace(/<[^<>]+>/g, '')}`,
          ],
        ]

        data.push(Array(firstRow.length).fill(''))
        data.push(tHeader)

        this.item.items.map((item, index) => {
          let rowData = [
            (index + 1).toString(),
            ApplyItemCategoryMap[item.category],
            item.product_id ? item.product.name : item.item.name,
            item.product_id ? item.product.code : item.item.code,
            item.number || 1,
            item.product_id
              ? this.getProductCustomParam(
                  item.product.custom_params,
                  ['规格型号', '规格', '型号'],
                  item.product_template,
                )
              : item.item.model_number,
            this.getProductCustomParam(
              item.product_id
                ? item.product.custom_params
                : item.item.custom_params,
              ['销售地'],
            ),
            this.getProductCustomParam(
              item.product_id
                ? item.product.custom_params
                : item.item.custom_params,
              ['特性1'],
            ),
          ]
          if (this.item.category == 2) {
            rowData.push(item.used_date)
            rowData.push(item.return_reason)
          }
          rowData.push(item.remark.replace(/<[^<>]+>/g, ''))
          data.push(rowData)
        })

        excel.export_json_to_excel({
          header: [],
          data,
          filename: `调拨单${this.item.order_number}`,
        })
        this.downloading = false
      })
    },

    async downloadPdf() {
      let title = '调拨单' + this.item.order_number
      let a4Height = 841.89
      let a4Width = 595.28
      let ele = document.querySelector('#printContent')
      ele.parentNode.style.overflow = 'visible'
      let that = this
      let scale = 2
      let rect = ele.getBoundingClientRect()
      let eleWidth = rect.width
      let eleHeight = rect.height

      html2Canvas(ele, {
        dpi: 144,
        scale: scale,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        width: eleWidth,
        height: eleHeight,
      }).then(function (canvas) {
        var context = canvas.getContext('2d')
        // 【重要】关闭抗锯齿
        context.mozImageSmoothingEnabled = false
        context.webkitImageSmoothingEnabled = false
        context.msImageSmoothingEnabled = false
        context.imageSmoothingEnabled = false

        let cw = eleWidth
        let ch = eleHeight
        let marginX = 40
        let marginY = 60
        // 显示区域大小
        let displayWidth = a4Width - marginX * 2
        let displayHeight = a4Height - marginY * 2
        // 比率
        let radio = cw / displayWidth
        // 换算高度
        let th = ch / radio

        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('', 'pt', 'a4')

        if (th < displayHeight) {
          PDF.addImage(pageData, 'JPEG', marginX, marginY, displayWidth, th)
        } else {
          // 计算分隔线
          let computedHeight = 0
          let fixedHeight = displayHeight * radio
          // 位置修正
          let beginY = ele.getBoundingClientRect().y

          let slices = []
          while (computedHeight < ch) {
            let target = that.getElementChildrenByTop(
              ele,
              fixedHeight + computedHeight,
              beginY,
            )

            let targetRect = target.getBoundingClientRect()
            let realHeight =
              targetRect.y - beginY + targetRect.height - computedHeight
            let borderFixed = 0
            if (target.nodeName == 'TR') {
              borderFixed = 1 * scale
            }

            slices.push({
              height: realHeight,
              fixed: borderFixed,
            })
            computedHeight += realHeight
          }

          let pages = slices.length
          let renderedHeight = 0
          let borderFixed = 0
          for (let i = 0; i < pages; i++) {
            const slice = slices[i]
            let img = context.getImageData(
              0,
              (renderedHeight - borderFixed) * scale,
              cw * scale,
              slice.height * scale,
            )
            let tmpCanvas = document.createElement('canvas')
            let tmpCtx = tmpCanvas.getContext('2d')
            let tmpCanvasWidth = cw * scale
            let tmpCanvasHeight = fixedHeight * scale + marginY * scale
            tmpCtx.scale(scale, scale)
            tmpCanvas.width = tmpCanvasWidth
            tmpCanvas.height = tmpCanvasHeight
            tmpCtx.fillStyle = '#fff'
            tmpCtx.fillRect(0, 0, tmpCanvasWidth, tmpCanvasHeight)
            tmpCtx.putImageData(img, 0, 0, 0, 0, img.width, img.height)

            tmpCtx.fillStyle = '#888'
            tmpCtx.font = '24px Arial'
            tmpCtx.textAlign = 'center'
            tmpCtx.fillText(
              '第' + (i + 1) + '/' + pages + '页',
              tmpCanvasWidth / 2,
              tmpCanvasHeight - (marginY * scale) / 2,
            )
            let res = tmpCanvas.toDataURL('image/jpeg', 1.0)
            PDF.addImage(
              res,
              'JPEG',
              marginX,
              marginY,
              displayWidth,
              displayHeight + marginY,
            )

            renderedHeight += slice.height
            borderFixed = slice.fixed

            if (i < pages - 1) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      })
    },
    getElementChildrenByTop(ele, top, start) {
      for (let i = 0; i < ele.children.length; i++) {
        const child = ele.children[i]
        const rect = child.getBoundingClientRect()
        let y = rect.y - start
        let ty = y + rect.height
        const marginTop = parseInt(window.getComputedStyle(child).marginTop)
        // 如果边距已超出需求高度
        if (y + marginTop > top) {
          if (i > 0) {
            return ele.children[i - 1]
          } else {
            return child.parentNode
          }
        }
        if (ty > top) {
          // 非根节点继续找
          let containerNodes = ['TABLE', 'DIV', 'UL', 'OL', 'TBODY']
          if (
            child.children.length > 0 &&
            containerNodes.indexOf(child.nodeName) != -1
          ) {
            return this.getElementChildrenByTop(child, top, start)
          }
          // 如果不是第一个节点则返回本节点的上一个节点
          if (i > 0) {
            return ele.children[i - 1]
          }
          // 递归到最近的一个兄弟元素
          else {
            let parent = child.parentNode
            let grand = parent.parentNode
            while (grand.children.length < 1) {
              grand = grand.parentNode
            }

            for (let j = 0; j < grand.children.length; j++) {
              const ele = grand.children[j]
              if (ele == parent && j > 0) {
                return grand.children[j - 1]
              }
            }
          }
        }
      }
      return ele
    },
    getProductCustomParam(params = [], label = [], template = {}) {
      if (label[0] == '规格型号' && template.custom_params) {
        let modelAliasParam = template.custom_params.find(
          (param) => param.model_alias,
        )
        if (modelAliasParam) {
          label = [modelAliasParam.label]
        }
      }
      const p = params.filter((item) => label.includes(item.label))[0]
      return p ? p.value : ''
    },
  },
}
</script>

<style scoped>
.print-title {
  text-align: center;
  font-size: 18px !important;
  margin-bottom: 20px;
  color: #000;
}
.item-list {
  font-size: 15px;
  color: #303133;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.option-btn {
  position: absolute;
  right: 50px;
  top: 16px;
}

/deep/ .el-dialog__body {
  padding-top: 10px;
}

/deep/ .el-table th.el-table__cell,
/deep/ .el-table td.el-table__cell,
/deep/ .el-table--border {
  background: none !important;
  border-color: #000;
}

/deep/ .el-table::before {
  background-color: #000;
}

/deep/ .el-table--border::after {
  background-color: #000;
}

/deep/ .el-descriptions__body,
/deep/ .el-table thead,
/deep/ .el-table {
  color: #000;
}

/deep/ .el-table .cell {
  overflow: visible !important;
}
</style>
<style>
@media print {
  html,
  body,
  div {
    font-size: 14px !important;
  }

  .print-title {
    margin-top: 30px;
  }

  table {
    table-layout: auto !important;
  }

  .el-table__cell,
  .el-table--border {
    display: table-cell !important;
    border-color: #333 !important;
  }

  .el-table__header-wrapper .el-table__header {
    width: 100% !important;
  }

  .el-table__body-wrapper .el-table__body {
    width: 100% !important;
  }

  .el-table__footer-wrapper .el-table__footer {
    width: 100% !important;
  }
}
</style>